export default {
  'Screenshot': 'Bildschirmkopie',
}